module.exports = __webpack_public_path__ + "img/award-btn-disabled.e08cf1f9.png";